import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "support-tickets-page" }
const _hoisted_2 = { class: "box-shadow-wrapper" }
const _hoisted_3 = { style: {"padding":"15px","display":"flex","gap":"12px","align-items":"center"} }
const _hoisted_4 = ["title"]
const _hoisted_5 = { style: {"display":"flex","justify-content":"space-between","align-items":"center","margin-bottom":"10px"} }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = {
  key: 0,
  style: {"display":"flex","gap":"4px","align-items":"center"}
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  class: "text-sm",
  style: {"padding":"0 8px"}
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "portlet light" }
const _hoisted_12 = {
  class: "portlet-body",
  style: {"padding":"0"}
}
const _hoisted_13 = { class: "table table-striped table-bordered table-advance table-hover flip-content" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { style: {"text-align":"center"} }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  colspan: "8",
  style: {"padding":"12px","background":"var(--root-background-color)"}
}
const _hoisted_18 = { style: {"display":"flex","gap":"16px","align-items":"flex-start"} }
const _hoisted_19 = { style: {"flex":"1","min-width":"0"} }
const _hoisted_20 = { style: {"margin-bottom":"12px"} }
const _hoisted_21 = { style: {"margin":"6px 0 0 0","white-space":"pre-wrap"} }
const _hoisted_22 = { style: {"display":"flex","gap":"8px","align-items":"center","flex-wrap":"wrap"} }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["value"]
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = ["value"]
const _hoisted_27 = ["disabled", "onClick"]
const _hoisted_28 = {
  key: 0,
  class: "fa fa-spinner fa-spin"
}
const _hoisted_29 = {
  key: 0,
  style: {"margin-top":"12px"}
}
const _hoisted_30 = { style: {"margin":"6px 0 0 0","white-space":"pre-wrap"} }
const _hoisted_31 = {
  key: 0,
  style: {"flex":"1","min-width":"0"}
}
const _hoisted_32 = { style: {"margin-top":"6px"} }
const _hoisted_33 = {
  key: 0,
  class: "fa fa-spinner fa-spin"
}
const _hoisted_34 = ["src", "onClick"]
const _hoisted_35 = {
  key: 0,
  class: "text-center text-muted",
  style: {"padding":"40px"}
}
const _hoisted_36 = ["src"]

import { ref, computed, onMounted } from 'vue';
import { SupportTicketsStore } from './SupportTicketsStore';
import { UserManager } from 'User/UserManager';
import {
	ISupportTicketItem,
	ISupportTicketsRequest,
	ISupportOption,
	ISupportTicketsResult
} from './Models/SupportTicketModels';

interface TicketViewModel extends ISupportTicketItem {
	isExpanded: boolean;
	isSaving: boolean;
	selectedCategoryId: number;
	selectedUrgencyId: number;
	originalCategoryId: number;
	originalUrgencyId: number;
	screenshot: string | null;
	screenshotLoaded: boolean;
	screenshotLoading: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SupportTicketsPage',
  setup(__props) {

const items = ref<TicketViewModel[]>([]);
const isLoading = ref(false);
const categories = ref<ISupportOption[]>([]);
const urgencies = ref<ISupportOption[]>([]);

const page = ref(1);
const pageSize = ref(50);
const totalCount = ref(0);
const showClosed = ref(false);
const totalPages = computed(() => Math.ceil(totalCount.value / pageSize.value) || 1);

const paginationInfo = computed(() => {
	if (totalCount.value === 0) return '';
	const from = (page.value - 1) * pageSize.value + 1;
	const to = Math.min(page.value * pageSize.value, totalCount.value);
	return `${from}-${to} of ${totalCount.value}`;
});

const getDatabaseName = (): string => {
	return UserManager.Instance.CurrentUser?.DbName;
};

const toViewModel = (item: ISupportTicketItem): TicketViewModel => ({
	...item,
	isExpanded: false,
	isSaving: false,
	selectedCategoryId: item.CategoryId,
	selectedUrgencyId: item.UrgencyId,
	originalCategoryId: item.CategoryId,
	originalUrgencyId: item.UrgencyId,
	screenshot: null,
	screenshotLoaded: false,
	screenshotLoading: false
});

const loadFilterOptions = () => {
	SupportTicketsStore.GetSupportInfo(getDatabaseName())
		.then(data => {
			categories.value = data.Categories || [];
			urgencies.value = data.Urgencies || [];
		});
};

const loadData = () => {
	isLoading.value = true;

	const request: ISupportTicketsRequest = {
		DataBaseName: getDatabaseName(),
		Page: page.value,
		PageSize: pageSize.value,
		ShowClosed: showClosed.value
	};

	SupportTicketsStore.GetTickets(request)
		.then((result: ISupportTicketsResult) => {
			items.value = result.Items.map(toViewModel);
			totalCount.value = result.TotalCount;
			page.value = result.Page;
		})
		.always(() => {
			isLoading.value = false;
		});
};

const goToPage = (p: number) => {
	if (p < 1 || p > totalPages.value || p === page.value) return;
	page.value = p;
	loadData();
};

const refresh = () => {
	page.value = 1;
	loadData();
};

const toggleClosed = () => {
	showClosed.value = !showClosed.value;
	page.value = 1;
	loadData();
};

const lightboxImage = ref<string | null>(null);

const openLightbox = (image: string) => {
	lightboxImage.value = image;
};

const closeLightbox = () => {
	lightboxImage.value = null;
};

const toggleExpand = (item: TicketViewModel) => {
	item.isExpanded = !item.isExpanded;
	if (item.isExpanded && !item.screenshotLoaded) {
		loadScreenshot(item);
	}
};

const loadScreenshot = (item: TicketViewModel) => {
	item.screenshotLoaded = true;
	item.screenshotLoading = true;

	SupportTicketsStore.GetTicketScreenshot({ DataBaseName: getDatabaseName(), TicketId: item.Id })
		.then(data => {
			item.screenshot = data && data.FileData ? data.FileData : null;
		})
		.always(() => {
			item.screenshotLoading = false;
		});
};

const isDirty = (item: TicketViewModel): boolean => {
	return item.selectedCategoryId !== item.originalCategoryId
		|| item.selectedUrgencyId !== item.originalUrgencyId;
};

const displayName = (option: ISupportOption): string => {
	return option.NameTranslation || option.Name;
};

const lifestatusClass = (name: string): string => {
	const status = (name || '').toLowerCase();
	if (status === 'enabled' || status === 'active') return 'label-success';
	if (status === 'disabled' || status === 'retired') return 'label-danger';
	return 'label-default';
};

const formatDate = (dateStr: string): string => {
	return dateStr ? new Date(dateStr).toLocaleString() : '';
};

const saveTicket = (item: TicketViewModel) => {
	item.isSaving = true;

	SupportTicketsStore.UpdateTicket({
		DataBaseName: getDatabaseName(),
		TicketId: item.Id,
		CategoryId: item.selectedCategoryId,
		UrgencyId: item.selectedUrgencyId
	})
		.then(() => {
			item.originalCategoryId = item.selectedCategoryId;
			item.originalUrgencyId = item.selectedUrgencyId;

			const cat = categories.value.find(c => c.Id === item.selectedCategoryId);
			const urg = urgencies.value.find(u => u.Id === item.selectedUrgencyId);
			if (cat) item.CategoryName = displayName(cat);
			if (urg) item.UrgencyName = displayName(urg);
		})
		.always(() => {
			item.isSaving = false;
		});
};

onMounted(() => {
	loadFilterOptions();
	loadData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("fieldset", null, [
        _createElementVNode("legend", { class: "title entity-wrapper" }, [
          _createElementVNode("span", { class: "entity-name" }, "Support Tickets"),
          _createElementVNode("span", { class: "entity-icon" }, [
            _createElementVNode("span", {
              class: "fa fa-ticket",
              "aria-hidden": "true"
            })
          ])
        ])
      ], -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "text-sm sps-btn sps-btn-outline sps-btn-primary",
          onClick: refresh
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
          _createTextVNode(" Refresh ", -1 /* CACHED */)
        ]))]),
        _createElementVNode("span", {
          class: _normalizeClass({ 'toggle-cross': !showClosed.value }),
          title: showClosed.value ? 'Show open tickets' : 'Show closed tickets',
          style: {"cursor":"pointer","color":"var(--main-color-1)","width":"34px","height":"34px","display":"flex","align-items":"center","justify-content":"center"},
          onClick: toggleClosed
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("i", {
            class: "fa fa-trash",
            style: {"font-size":"20px"}
          }, null, -1 /* CACHED */)
        ]))], 10 /* CLASS, PROPS */, _hoisted_4)
      ])
    ]),
    _createCommentVNode(" Pagination "),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(paginationInfo.value), 1 /* TEXT */),
      (totalPages.value > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-default",
              disabled: page.value <= 1,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPage(page.value - 1)))
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1 /* CACHED */)
            ]))], 8 /* PROPS */, _hoisted_8),
            _createElementVNode("span", _hoisted_9, "Page " + _toDisplayString(page.value) + " of " + _toDisplayString(totalPages.value), 1 /* TEXT */),
            _createElementVNode("button", {
              class: "btn btn-sm btn-default",
              disabled: page.value >= totalPages.value,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(page.value + 1)))
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1 /* CACHED */)
            ]))], 8 /* PROPS */, _hoisted_10)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createCommentVNode(" Data Table "),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("table", _hoisted_13, [
          _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { style: {"width":"30px"} }),
              _createElementVNode("th", null, "Incident number"),
              _createElementVNode("th", null, "Name"),
              _createElementVNode("th", null, "Category"),
              _createElementVNode("th", null, "Urgency"),
              _createElementVNode("th", null, "Status"),
              _createElementVNode("th", null, "Reporter"),
              _createElementVNode("th", null, "Created"),
              _createElementVNode("th", null, "Updated")
            ])
          ], -1 /* CACHED */)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.Id
              }, [
                _createCommentVNode(" Master row "),
                _createElementVNode("tr", {
                  style: {"cursor":"pointer"},
                  onClick: ($event: any) => (toggleExpand(item))
                }, [
                  _createElementVNode("td", _hoisted_15, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa", item.isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'])
                    }, null, 2 /* CLASS */)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.CaseNumber), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(item.Name), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(item.CategoryName), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(item.UrgencyName), 1 /* TEXT */),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["label", lifestatusClass(item.LifestatusName)])
                    }, _toDisplayString(item.LifestatusName), 3 /* TEXT, CLASS */)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.ReporterName), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(formatDate(item.CreateDate)), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(formatDate(item.ChangeDate)), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_14),
                _createCommentVNode(" Detail row "),
                (item.isExpanded)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                      _cache[15] || (_cache[15] = _createElementVNode("td", null, null, -1 /* CACHED */)),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _cache[9] || (_cache[9] = _createElementVNode("strong", null, "Description:", -1 /* CACHED */)),
                              _createElementVNode("p", _hoisted_21, _toDisplayString(item.Description), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _cache[11] || (_cache[11] = _createElementVNode("span", { style: {"font-size":"12px"} }, "Category", -1 /* CACHED */)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((item.selectedCategoryId) = $event),
                                class: "form-control",
                                style: {"height":"30px","font-size":"13px","width":"160px","display":"inline-block"},
                                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (cat) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: cat.Id,
                                    value: cat.Id
                                  }, _toDisplayString(displayName(cat)), 9 /* TEXT, PROPS */, _hoisted_24))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 8 /* PROPS */, _hoisted_23), [
                                [
                                  _vModelSelect,
                                  item.selectedCategoryId,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _cache[12] || (_cache[12] = _createElementVNode("span", { style: {"font-size":"12px"} }, "Urgency", -1 /* CACHED */)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((item.selectedUrgencyId) = $event),
                                class: "form-control",
                                style: {"height":"30px","font-size":"13px","width":"160px","display":"inline-block"},
                                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(urgencies.value, (urg) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: urg.Id,
                                    value: urg.Id
                                  }, _toDisplayString(displayName(urg)), 9 /* TEXT, PROPS */, _hoisted_26))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 8 /* PROPS */, _hoisted_25), [
                                [
                                  _vModelSelect,
                                  item.selectedUrgencyId,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _createElementVNode("button", {
                                class: "sps-btn sps-btn-outline sps-btn-primary",
                                style: {"height":"30px"},
                                disabled: !isDirty(item),
                                onClick: _withModifiers(($event: any) => (saveTicket(item)), ["stop"])
                              }, [...(_cache[10] || (_cache[10] = [
                                _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                _createTextVNode(" Save ", -1 /* CACHED */)
                              ]))], 8 /* PROPS */, _hoisted_27),
                              (item.isSaving)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_28))
                                : _createCommentVNode("v-if", true)
                            ]),
                            (item.Solution)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Solution:", -1 /* CACHED */)),
                                  _createElementVNode("p", _hoisted_30, _toDisplayString(item.Solution), 1 /* TEXT */)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ]),
                          (item.screenshotLoading || item.screenshot)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _cache[14] || (_cache[14] = _createElementVNode("strong", null, "Screenshot:", -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_32, [
                                  (item.screenshotLoading)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_33))
                                    : (item.screenshot)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          src: item.screenshot,
                                          alt: "Screenshot",
                                          style: {"max-width":"100%","border":"1px solid #ddd","border-radius":"4px","cursor":"zoom-in"},
                                          onClick: _withModifiers(($event: any) => (openLightbox(item.screenshot)), ["stop"])
                                        }, null, 8 /* PROPS */, _hoisted_34))
                                      : _createCommentVNode("v-if", true)
                                ])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _createCommentVNode(" No data "),
        (items.value.length === 0 && !isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, " No support tickets found "))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createCommentVNode(" Screenshot lightbox "),
    (lightboxImage.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: closeLightbox,
          style: {"position":"fixed","top":"0","left":"0","right":"0","bottom":"0","z-index":"10000","background":"rgba(0, 0, 0, 0.85)","display":"flex","align-items":"center","justify-content":"center","cursor":"zoom-out"}
        }, [
          _createElementVNode("img", {
            src: lightboxImage.value,
            alt: "Screenshot",
            style: {"max-width":"95vw","max-height":"95vh","box-shadow":"0 0 30px rgba(0, 0, 0, 0.6)"}
          }, null, 8 /* PROPS */, _hoisted_36)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})